import React from 'react';
import Features from './Features';
import Advantages from './Advantages';
import Footer from '../Footer';
import { FAQ } from '../FAQ/faqs';


function Businessintelligence() {
  return (
    <>
<Features docname="Business Intelligence"/>
<Advantages docname="Business Intelligence"/>
<FAQ category="About Accxchange"/>
<Footer segment="Smarty Home"/>

    </>
  );
}

export default Businessintelligence;
